import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ImageHomeHouse from "../../images/website/home-house.png";
import ImageHomeId from "../../images/website/home-id.png";
import ImageHomePersonal from "../../images/website/home-personal.png";
import ImageHomeV from "../../images/website/home-v.png";
import ImageAboutCash from "../../images/website/about_logo_cash.png";
import ImageLogoSm from "../../images/website/about_sm_logo.png";
import LayoutWebsite from "../../components/LayoutWebsite";
import FooterWebsite from "../../components/FooterWebsite";
import "./styles.css";

function WebsiteAbout() {
  return (
    <LayoutWebsite>
      <div className="about-page">
        <header className="hero">
          <Grid className="container" container>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                maxWidth: "800px",
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
                padding: {
                  xs: "6rem 0 4rem",
                  md: "8rem 0 200px",
                },
              }}
            >
              <Typography
                variant="h3"
                component="h1"
                sx={{ marginBottom: "2rem" }}
              >
                <strong>
                  “RentBeets bolsters the relationship between tenants and
                  landlords.”
                </strong>
              </Typography>
              <Typography variant="body1" component="p">
                RentBeets mission is to reduce apartment vacancies for
                responsible landlords while also reducing the emotional and
                financial strain of moving for tenants.
              </Typography>
            </Grid>
          </Grid>
        </header>
        <section className="description">
          <Grid
            container
            className="container"
            spacing={{ xs: 0, md: 4 }}
            sx={{
              padding: "2rem !important",
              marginTop: {
                xs: 0,
                md: "-150px !important",
              },
            }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "top",
                },
              }}
            >
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: {
                    xs: "2rem",
                    md: "3rem",
                  },
                  borderLeft: {
                    xs: "none",
                    md: "10px solid black",
                  },
                  paddingLeft: {
                    xs: "0",
                    md: "1rem",
                  },
                  paddingBottom: "1rem",
                }}
              >
                <strong>
                  We rent apartments, not beets, but beets are good for you, and
                  so is RentBeets!
                </strong>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
              }}
            >
              <Typography variant="body1" component="p">
                Combining our experiences of renting and listening to the
                concerns of hundreds of landlords, property managers, and
                tenants we discovered two common themes, online apartment
                listing information is unreliable and vacant apartments hurt the
                bottom line.
              </Typography>
              <Typography variant="body1" component="p">
                RentBeets exists to work alongside Property Managers and
                Tenants. With no necessary software to download, our platform
                allows for an easy and scalable solution to rent your apartments
                quicker. RentBeets allows vacant apartments to be referred to by
                your current tenants and increases transparency between property
                managers and tenants with a clear, concise platform. RentBeets
                reduces the amount of days an apartment is vacant by allowing
                the property manager to incentivize the tenant moving out.
                RentBeets has created a process to make qualified Tenants more
                visible to property managers which involves informative tenant
                applications, transparent lease details, and accurate apartment
                descriptions. With the average vacant apartment costing property
                owners thousands of dollars and tenants not receiving full
                information about the apartment prior to signing a lease, we are
                here to help!
              </Typography>
              <Typography variant="body1" component="p">
                Through digital showings and the option of a scheduled virtual
                tour we strive to keep people safe and comfortable. Based on
                research and market trends we have found that 70% of tenants are
                willing to rent an apartment virtually with clear lease
                information, good photos and reliable comments. By saving money
                for landlords, increasing relationships between tenants and
                landlords we are striving to make peoples household lives better
                along with implementing better business practice.
              </Typography>
              <Typography variant="body1" component="p">
                By saving money for landlords, increasing relationships between
                tenants and landlords we are striving to make peoples household
                lives and b usiness practices better.
              </Typography>
            </Grid>
          </Grid>
        </section>
        <section className="estate">
          <Grid
            container
            className="container"
            sx={{
              padding: "2rem !important",
              marginTop: {
                xs: "0",
                md: "100px !important",
              },
            }}
          >
            <Grid item xs={12} md={8} sx={{}}>
              <Typography variant="h4" component="h3">
                <strong>Estate of Mind</strong>
              </Typography>
              <Typography variant="body1" component="p">
                Landlords don't see your personal information. We use TransUnion
                SmartMove to run all tenant screenings. Venmo payment processing
                is used for rewards.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <img
                src={ImageLogoSm}
                style={{ maxWidth: "330px", width: "80%" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginTop: "10px",
                }}
              >
                <img src={ImageHomeV} style={{ maxWidth: "45px" }} />
                <img src={ImageAboutCash} style={{ maxWidth: "230px" }} />
              </div>
            </Grid>
          </Grid>
        </section>
        <section className="realestate">
          <Grid
            className="container"
            sx={{
              padding: "2rem !important",
              marginTop: {
                xs: "0",
                md: "100px !important",
              },
              marginBottom: {
                xs: "0",
                md: "4rem!important",
              },
            }}
          >
            <Typography variant="h4" component="h3">
              <strong>Real Estate 101:</strong>
            </Typography>
            <Typography variant="p" component="p">
              Zumper’s research says 70% of tenants are willing to rent an
              apartment digitally:
            </Typography>
            <Typography
              variant="p"
              component="p"
              sx={{ paddingBottom: "1rem" }}
            >
              <a
                href="https://www.prnewswire.com/news-releases/more-than-70-of-renters-would-lease-an-apartment-sight-unseen-thanks-to-3d-virtual-tours-301111514.html"
                target="_blank"
              >
                More than 70% of Renters Would Lease an Apartment Sight-Unseen
                Thanks to 3D Virtual Tours
              </a>
            </Typography>
            <Typography variant="p" component="p">
              Tenant Turnover $2500:
            </Typography>
            <Typography
              variant="p"
              component="p"
              sx={{ paddingBottom: "1rem" }}
            >
              <a
                href="https://learn.roofstock.com/blog/our-first-tenant-turnover-experience-how-much-it-cost-and-what-we-learned"
                target="_blank"
              >
                Our first tenant turnover experience: Costs & what we learned
              </a>
            </Typography>
            <Typography variant="p" component="p">
              According to mysmartmove.com Average costs of eviction $3500{" "}
            </Typography>
            <Typography
              variant="p"
              component="p"
              sx={{ paddingBottom: "1rem" }}
            >
              <a href="https://www.mysmartmove.com/" target="_blank">
                www.mysmartmove.com
              </a>
            </Typography>
          </Grid>
        </section>
        <FooterWebsite />
      </div>
    </LayoutWebsite>
  );
}

export default WebsiteAbout;
